export default {
  namespaced:true,
  state : {
    token:localStorage.getItem('access-Token') ,
  },
  
  getters : {
    GETTERS_TOKEN: (state) => state.token,
  },
  
  mutations : {
    MUTATION_TOKEN (state, data) {
      state.token = data
    },
  },
  actions : {
    ACTION_LOGOUT ({commit}) {
      //clear token
      commit('MUTATION_TOKEN',null)
      localStorage.removeItem('access-Token') 
      //clear profile
      commit('userProfile/MUTATION_ME',null, {root: true})
    }
  }
} 